<template>
  <div id="ModelBills">
    <a-modal
      title="订单详情"
      width="620px"
      :visible="this.$store.state.isShowBillsModel"
      @cancel="closeModel"
      @ok="closeModel"
    >
      <a-table
        :columns="productColumns"
        :rowKey="record => record.id"
        :dataSource="tableProductBillsData"
        size="small"
        :pageSize="2"
      >
        <div slot="paidAt" slot-scope="text">
          {{ text | timestrampFormat }}
        </div>
        <div slot="status" slot-scope="text">
          {{ text | billStatusFilter }}
        </div>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { GetBillsInfoWithCrmID } from '@/api/QkidsApi.js'

const productColumns = [
  { title: '订单', dataIndex: 'name', key: 'name' },
  { title: '订单时间', dataIndex: 'paidAt', key: 'paidAt', scopedSlots: { customRender: 'paidAt' } },
  { title: '渠道', dataIndex: 'payChannel', key: 'payChannel' },
  { title: '金额', dataIndex: 'actualPrice', key: 'actualPrice' },
  { title: '状态', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' } }
]
export default {
  name: 'ModelBills',
  data () {
    return {
      selectCrmID: this.modelBillsCrmid,
      productColumns,
      tableProductBillsData: []
    }
  },
  props: ['modelBillsCrmid'],
  methods: {
    closeModel (e) {
      this.$store.state.isShowBillsModel = false
    }
  },
  watch: {
    modelBillsCrmid: function () {
      this.selectCrmID = this.modelBillsCrmid
      if (this.selectCrmID === 0) {
        // this.closeModel()
        this.tableProductBillsData = []
      } else {
        GetBillsInfoWithCrmID(this.selectCrmID)
          .then(req => {
            this.tableProductBillsData = req.data.result
            console.log(req)
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  filters: {
    billStatusFilter: (val) => {
      switch (val) {
        case 20:
          return '已支付'
        case 30:
          return '支付超时'
        case 80:
          return '已退款'
      }
    },
    timestrampFormat: (timestamp) => {
      var d = new Date(timestamp * 1000)
      var date = (d.getFullYear()) + '-' +
        (d.getMonth() + 1) + '-' +
        (d.getDate()) + ' ' +
        (d.getHours()) + ':' +
        (d.getMinutes()) + ':' +
        (d.getSeconds())
      return date
    }
  }
}
</script>
